import { render } from "./NavigationIcon.vue?vue&type=template&id=682fd3e6&scoped=true"
import script from "./NavigationIcon.vue?vue&type=script&lang=js"
export * from "./NavigationIcon.vue?vue&type=script&lang=js"

import "./NavigationIcon.vue?vue&type=style&index=0&id=682fd3e6&scoped=true&lang=css"

import exportComponent from "/Users/user/Development/spin-demo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-682fd3e6"]])

export default __exports__